import flatten from 'lodash.flatten';
import { SEARCH_TERM, AND, KEYWORD } from '../constants';
const buildFieldName = fieldName => `${fieldName}.${KEYWORD}`;
const getFiltersProps = filters => flatten(filters.map(({
  propsToDisplay
}) => propsToDisplay));
const buildSearchValuesCheckboxSelect = (query, rangeFilters, checkboxFilters, selectFilters) => {
  const queryParams = Object.keys(query).filter(param => param !== SEARCH_TERM);
  const rangeFilterProps = getFiltersProps(rangeFilters);
  const checkboxFilterProps = getFiltersProps(checkboxFilters);
  const selectFilterProps = getFiltersProps(selectFilters);
  const {
    values,
    valuesOr
  } = queryParams.reduce((acc, queryParam) => {
    const isQueryParamString = typeof query[queryParam] === 'string';
    if (isQueryParamString) {
      if (rangeFilterProps.includes(queryParam)) {
        const [min, max] = query[queryParam].split('-');
        if (min === 'NaN' || max === 'NaN') return acc;
        acc.values.push({
          range: {
            [queryParam]: {
              gte: Number(min),
              lte: Number(max)
            }
          }
        });
      } else if (checkboxFilterProps.includes(queryParam) || selectFilterProps.includes(queryParam)) {
        acc.values.push({
          match: {
            [buildFieldName(queryParam)]: query[queryParam]
          }
        });
      }
    } else {
      const checkboxFilter = checkboxFilters.filter(({
        propsToDisplay: [firstPropToDisplay]
      }) => firstPropToDisplay === queryParam);
      if (!checkboxFilter.length) return acc;
      const shouldBuildCheckboxOrValues = checkboxFilter.filter(({
        operator
      }) => operator !== AND).length;
      const fieldToPush = shouldBuildCheckboxOrValues ? acc.valuesOr : acc.values;
      query[queryParam].forEach(value => {
        fieldToPush.push({
          match: {
            [buildFieldName(queryParam)]: value
          }
        });
      });
    }
    return acc;
  }, {
    values: [],
    valuesOr: []
  });
  return {
    values,
    valuesOr
  };
};
export default buildSearchValuesCheckboxSelect;
//# sourceMappingURL=build-search-values-checkbox-select.js.map